import Menu from "components/Menu";

import GettingStarted from "components/ReportClaim/Pages/1_GettingStarted";
import DriverInfo from "components/ReportClaim/Pages/2_DriverInfo";
import VehicleInfo from "components/ReportClaim/Pages/3_VechicleInfo";
import LossInfo from "components/ReportClaim/Pages/4_LossInfo";
import AdditionalInfo from "components/ReportClaim/Pages/5_AdditionalInfo";
import Confirm from "components/ReportClaim/Pages/6_Confirm";
import Submit from "components/ReportClaim/Pages/7_Submit";
import PassengersInfo from "components/ReportClaim/Pages/8_PassengersInfo";
import InjuriesInfo from "components/ReportClaim/Pages/9_InjuriesInfo";

import FormWrapper from "components/ReportClaim/FormWrapper";
import RoundyModal from "components/RoundyModal";
import { useNavigate } from "react-router-dom";
import { getDisclosureAgreementText, nonCoveredDriverVehicleDisclosure } from "components/ReportClaim/DisclousureAgreement";
import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import {
  getAddress,
  getDrivers,
  sendFNOLData,
  sendFNOLEmail
} from "services/Api";
import { QUESTIONS } from "components/ReportClaim/Questions";

const ReportClaim = (props) => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [address, setAddress] = useState({});
  const [refNum, setRefNum] = useState("");
  const [removeLNSentence, setRemoveLNSentence] = useState(false);
  const [error, setError] = useState({});

  const { userData } = props.user;
  const { systemId, policyNumber, env } = userData;
  const navigate = useNavigate();
  const closeModal = () => navigate("/home");

  const userState = userData.state == "Michigan"
    ? "MI"
    : userData.state == "Pennsylvania"
    ? "PA"
    : "NJ"
  const dataInitial = {
    state: userState,
    drivers: [],
    user: { ReportType: "I am insured with CURE", LoggedIn: true, state: userState },
    vehicleInfo: {},
    cureDriverInfo: {},
    lossInfo: {},
    lossInformation: {},
    injuriesInLossLists: [],

    vehicles: userData.idCardData.map((data) => {
      return {
        ...data,
        VIN: data.vehidentificationnumber,
        make: data.manufacturer,
        year: data.modelyr,
      };
    }),
  };
  const [data, setData] = useState(dataInitial)

  const formSteps = (formData) => {
    return {
      GettingStarted: { displayIndex: 1, component: GettingStarted, title: "Getting Started" },
      DriverInfo: { displayIndex: 2, component: DriverInfo, title: "Driver" },
      VehicleInfo: { displayIndex: 3, component: VehicleInfo, title: "Vehicle" },
      LossInfo: { displayIndex: 4, component: LossInfo, title: "Loss" },
      AdditionalInfo: { displayIndex: 5, component: AdditionalInfo, title: "Additional Info",},
      Passengers: formData?.wereThereAnyPassengersInVehicle == "Yes" ? { parentIndex: 5, component: PassengersInfo, title: "Passengers",  } : null,
      Injuries: formData?.wereThereAnyPassengersInVehicle == "Yes" ? { parentIndex: 5, component: InjuriesInfo, title: "Injuries", } : null,
      Confirm: { displayIndex: 6, component: Confirm, title: "Confirm", isLast: true },
    };
  };

  useEffect(() => {
    fetchDrivers()
    fetchAddress()
  }, []);

  const fetchDrivers = async () => {
    setIsLoading(true);
    try {
      const response = await getDrivers(systemId, policyNumber, env);
      const data = response.data.result;
      var driversArr = [];

      for (var i = 0; i < Object.keys(data).length; i++) {
        var date = new Date(data[i].dob);
        var year;
        var month;
        var day;
        var newDateFormat;
        // Formats date of birth (edge)
        if (data[i].dob[2] === "-") {
          year = date.getFullYear();
          month = date.getMonth() + 1;
          day = date.getDate();
          newDateFormat = `${month}/${day}/${year}`;
        } else {
          year = date.getFullYear();
          month = date.getMonth() + 1;
          day = date.getDate();
          newDateFormat = `${month}/${day}/${year}`;
        }
        // Organizes drivers
        if (data[i].type === "Driver") {
          var driversStored = {};
          driversStored["fullName"] = data[i]?.name;
          driversStored["FirstName"] = data[i]?.firstName;
          driversStored["LastName"] = data[i]?.lastName;
          driversStored["monthSelect"] = month;
          driversStored["daySelect"] = day;
          driversStored["yearSelect"] = year;
          driversStored["DOB"] = newDateFormat;
          driversStored["mStatus"] = data[i]?.maritalStatus;
          driversStored["gender"] = data[i]?.gender;
          driversStored["DLNumber"] = data[i]?.licensenumber;
          driversStored["DLState"] = data[i]?.licensedStateProvCd;
          driversStored["relationToPolicyHolder"] = data[i]?.relationship;
          driversStored["driverStatus"] = "";
          driversStored["initialType"] = "Driver";
          driversStored["currStatus"] = data[i]?.driverStatus;

          // If first driver, set phone and email to policyholder phone and email
          const isInsured = i == 0
          const emailAddr = isInsured ? userData?.policyEmailAddress : data[i]?.emailAddr
          const phoneNumber = isInsured ? userData?.policyPhoneNumber?.replace(/\D/g,'') : (data[i]?.phoneNumber && data[i]?.phoneNumber?.replace(/\D/g,''))
          driversStored["EmailAddress"] = emailAddr
          driversStored["PhoneNumber"] = phoneNumber
  
          driversArr.push(driversStored);
        }
      }
      setData((prev) => {return {...prev, drivers: driversArr}})
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchAddress = async () => {
    try {
      const response = await getAddress(systemId, policyNumber, env);
      const data = response?.data?.result;
      var currResidence = {};
      if (Object.keys(data)?.length !== 0) {
        if ("Address1" in data[0]) {
          var dataMail = data.filter((val) => {
            return (
              val.AddressType == "InsuredMailingAddr" || val.AddressType == null
            );
          });
          if (dataMail?.length) {
            currResidence = {
              address1: dataMail[dataMail.length - 1].Address1,
              address2: dataMail[dataMail.length - 1].Address2,
              city: dataMail[dataMail.length - 1].City,
              state: dataMail[dataMail.length - 1].State,
              zip: dataMail[dataMail.length - 1].Zip,
              county: dataMail[dataMail.length - 1].County,
              region: dataMail[dataMail.length - 1].Region,
              insuredDriver: dataMail[dataMail.length - 1].FullName,
            };
          }
        } else {
          currResidence = {
            address1: data[data.length - 1].Address1,
            address2: data[data.length - 1].Address2,
            city: data[data.length - 1].City,
            state: data[data.length - 1].State,
            zip: data[data.length - 1].Zip,
            county: data[data.length - 1].County,
            region: data[data.length - 1].Region,
            firstName: data[data.length - 1].FirstName,
            lastName: data[data.length - 1].LastName,
            insuredDriver:
              data[data.length - 1].FirstName +
              " " +
              data[data.length - 1].LastName,
          };
        }
        currResidence.zip = currResidence.zip.split("-")[0];
      }
      setAddress(currResidence);
    } catch (err) {
      console.error(err);
    }
  };

  const formatTime = (date) => {
    if(date == null || date == undefined || date == "")
      return null
    const dateObj = new Date(date);
    const options = { hour: "numeric", minute: "2-digit", hour12: true };
    const formattedTime = dateObj.toLocaleTimeString("en-US", options);
    return formattedTime;
  };

  const formatDate = (date) => {
    if(date == null || date == undefined || date == "")
      return null

    const padNumber = (num) => {
      return String(num).padStart(2, '0')
    }

    const dateObj = new Date(date);
    const formattedDate = [dateObj.getFullYear(), padNumber(dateObj.getMonth() + 1), padNumber(dateObj.getDate())].join("-")
    return formattedDate;
  };

  const handleSubmit = async (formData) => {
    try {
      setIsLoading(true);
      setIsSubmitted(true);

      const policyHolderInfo = {
        FirstName: userData.firstName,
        LastName: userData.lastName,
        PhoneNumber: userData.policyPhoneNumber,
        EmailAddress: userData.policyEmailAddress,
        PolicyNumber: policyNumber,
        StreetAddress: address.address1,
        ApartmentNo: address.address2,
        City: address.city,
        State: address.state,
        ZipCode: address.zip,
      };

      const claimData = {
        policyHolderInfo: policyHolderInfo,
        user: formData.user,
        involvedDriver: formData?.involvedDriverIndex,
        vehicleInfo: formData.vehicleInfo,
        involvedVehicle: formData?.involvedVehicleIndex,
        cureDriverInfo: {
          ...formData.cureDriverInfo,
          DOB: formatDate(formData.cureDriverInfo.DOB)
        },
        lossInfo: {
          DateOfLoss: formatDate(formData.lossInfo.DateOfLoss),
          TimeOfLoss: formatTime(formData.lossInfo.TimeOfLoss),
        },
        lossInformation: formData.lossInformation,
        injuriesInLossLists: formData.injuriesInLossLists,
        passengersInvehiclesLists: formData.passengersInvehiclesLists,
        anyOtherVehiclesInvolved: formData.anyOtherVehiclesInvolved,
        wereThereAnyPassengersInVehicle:
          formData.wereThereAnyPassengersInVehicle,
        wereThereAnyInjuriesInLoss: formData.wereThereAnyInjuriesInLoss,
        env: userData?.env
      };

      const response = await sendFNOLData(claimData);
      const {lossNumber, claimID, Result} = response.data;

      if (!["Duplicate", "Blocked"]?.includes(Result)){
        sendEmailToRep(claimID, lossNumber, claimData)
      }
      setRefNum(lossNumber);
      setError(GetErrorMessage(Result))

      if (formData?.involvedDriverIndex == "other" || formData?.involvedVehicleIndex == "other") {
        setRemoveLNSentence(true)
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const sendEmailToRep = (claimID, lossNumber, claimData) => {
    const htmlText = buildTable(lossNumber, claimData)
    const mailObj = {
      subject: `[My Account FNOL Claim Form] - Policy #: ${policyNumber} - Transaction #: ${lossNumber}`,
      content: htmlText,
      claimID: claimID,
      isLoggedIn: true,
      reportType: ""
    }
    sendFNOLEmail(mailObj)
  }

  const GetErrorMessage = (error) => {
    switch(error){
      case "Duplicate":
        return {
          header: <>
            <p>There is already a claim on your policy for this date of loss.</p> 
            <p>If you have any questions, please call us at 800-535-2873.</p>
          </>
        }
    }
  }

  return (
    <>
      <Menu
        Title={"REPORT A CLAIM"}
        FirstName={userData.firstName}
        userData={userData}
      />

      {isLoading && (
        <div
          className="d-flex justify-content-center align-items-end"
          style={{ height: "30vh" }}
        >
          <Spinner animation="border" />
        </div>
      )}

      {!isLoading && !isSubmitted && (
        <FormWrapper
          formSteps={formSteps}
          data={data}
          onSubmit={handleSubmit}
        />
      )}

      {!isLoading && isSubmitted && <Submit formData={data} refNum={refNum} error={error} removeLNSentence={removeLNSentence} />}

      <RoundyModal
        title="DISCLOSURE AGREEMENT"
        body={
          <>
            <p>{getDisclosureAgreementText(userData.state)}</p>
          </>}
        rightButtonText="I AGREE"
        leftButtonText="DECLINE"
        showModal={true}
        closeModal={closeModal}
        onLeftButtonClick={closeModal}
      />
    </>
  );
};

const tableRow = (fieldName, fieldValue) => {
  return `<tr><td>${fieldName}</td><td>${fieldValue || ""}</td></tr>`
}

const tableHeader = (header) => {
  return `<tr><td colspan="2" style="text-align: center"><b>${header}</b></td></tr>`
}

const buildTable = (lossNumber, claimData) => {
  delete claimData.user.LoggedIn
  var table = '<h1 text-align="center">My Account FNOL Claim Form</h1><table border="1">'
  table += tableRow("Transaction number:", lossNumber)
  
  const sections = [
    {
      header: "Your Information",
      content: claimData.user
    },
    {
      header: "Loss Information",
      content: claimData.lossInfo
    },
    {
      header: "CURE Policy Information",
      content: claimData.policyHolderInfo
    }
  ]

  sections.forEach(section => {
    if(section.header)
      table += tableHeader(section.header)
    for (const key in section.content) {
      table += tableRow(key, section.content[key])
    }
  })

  const questionSections = [
    {
      header: "CURE Vehicle Information",
      questions: QUESTIONS.VEHICLE_INFO,
      content: claimData.vehicleInfo
    },
    {
      header: "CURE Driver Information",
      questions: QUESTIONS.CURE_DRIVER_INFO,
      content: claimData.cureDriverInfo
    },
    {
      header: "Loss Information",
      questions: QUESTIONS.LOSS_INFORMATION,
      content: claimData.lossInformation
    },
    {
      questions: QUESTIONS.ADDITIONAL_INFO,
      content: claimData
    }
  ]

  questionSections.forEach(section => {
    if(section.header)
      table += tableHeader(section.header)
    for (const key in section.questions) {
      table += tableRow(section.questions[key], section.content[key])
    }
  })
  
  if (claimData.wereThereAnyPassengersInVehicle === 'Yes') {
    claimData.passengersInvehiclesLists.forEach((passenger, passengerIndex) => {
      table += tableHeader(`Passenger ${passengerIndex + 1}`)
      for (const key in QUESTIONS.PASSENGER) {
        table += tableRow(QUESTIONS.PASSENGER[key], passenger[key])
      }
    })
  }
  if (claimData.wereThereAnyInjuriesInLoss === 'Yes') {
    claimData.injuriesInLossLists.forEach((injuredPerson, injuryIndex) => {
      table += tableHeader(`Injured Person ${injuryIndex + 1}`)
      for (const key in QUESTIONS.INJURED_PERSON) {
        table += tableRow(QUESTIONS.INJURED_PERSON[key], injuredPerson[key])
      }
    })
  }

  table += `<tr><td colspan="2" style="text-align: center"><b>Attestation</b></td></tr>`
  table += `<tr><td width="50%">I hereby certify that, to the best of my knowledge, the provided information is true and accurate. ${getDisclosureAgreementText(claimData.user.state)}</td><td>"Yes"</td></tr>`
  table += '</table>'
  return table
}

export default ReportClaim;
